import { DialogProps } from '@material-ui/core';
import React from 'react';
import { useLocalization } from 'localization/useLocalization';
import { StringModelForm } from 'framework/forms/StringModelForm';
import { IPaymentMethod, paymentMethodsCommand_patchName } from 'gen/ApiClient';

interface IProps extends DialogProps {
	item: IPaymentMethod;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const PaymentMethodNameForm = ({ item, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<StringModelForm
			label={strings.name}
			formTitle={strings.changeWhat(strings.name)}
			notifyMessage={strings.changedWhat(strings.paymentMethod)}
			submitFunction={val => paymentMethodsCommand_patchName({ paymentMethodId: item.id, name: val })}
			initialValue={item.identifier ?? ''}
			submitText={strings.update}
			{...rest}
		/>
	);
};
